import TripOriginOutlinedIcon from '@mui/icons-material/TripOriginOutlined';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import styled from '@mui/system/styled';
import CriticalPriority from 'public/assets/img/priority-critical.svg';
import HighPriority from 'public/assets/img/priority-high.svg';
import MediumPriority from 'public/assets/img/priority-medium.svg';
import LowPriority from 'public/assets/img/priority-low.svg';
import NonePriority from 'public/assets/img/priority-none.svg';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import ChangeCircleOutlinedIcon from '@mui/icons-material/ChangeCircleOutlined';
import UserAvatar from 'components/Avatar';
import CustomAvatarGroup from 'components/Avatar/AvatarGroup/AvatarGroup.cmp';
import TeamAvatar from 'components/Avatar/TeamAvatar/TeamAvatar.cmp';
import { Typography } from '@mui/material';

const StyledStatusIcon = styled(FiberManualRecordIcon)({
  fontSize: 18,
});

export const statusDropdownData = [
  {
    label: 'In Progress',
    value: 'In Progress',
    id: 'In Progress',
    color: '#F58500',
    progressBarBg: '#CCCBFF',
    progressBarFg: '#5555FF',
    startIcon: <StyledStatusIcon color="inherit" />,
  },
  {
    label: 'Incomplete',
    value: 'Incomplete',
    id: 'Incomplete',
    color: '#E65100',
    progressBarBg: '#FFCDD2',
    progressBarFg: '#EF5350',
    startIcon: <StyledStatusIcon color="inherit" />,
  },
  {
    label: 'Submitted',
    value: 'Submitted',
    id: 'Submitted',
    color: '#04B86C',
    progressBarBg: '#C8E6C9',
    progressBarFg: '#04B86C',
    startIcon: <StyledStatusIcon color="inherit" />,
  },
];
